import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return {
    headers: {
      Authorization: `Bearer ${user?.token}`,
    },
  };
};

export const resetDailyTarget = async (userId) => {
  const response = await axios.put(`${API_URL}/admin/reset-target`, { userId }, getAuthHeader());
  return response.data;
};

export const adminGetDailyStatistics = async () => {
  const response = await axios.get(`${API_URL}/admin/daily-stats`, getAuthHeader());
  return response.data;
};


const getDailyStatistics = async () => {
  const response = await axios.get(`${API_URL}/daily-stats`, getAuthHeader());
  return response.data;
};

const setDailyStatistics = async (target) => {
  const response = await axios.post(`${API_URL}/target`, { target }, getAuthHeader());
  return response.data;
};

// Bot Controls
const startBot = async () => {
  const response = await axios.post(`${API_URL}/start`, {}, getAuthHeader());
  return response.data;
};

const stopBot = async () => {
  const response = await axios.post(`${API_URL}/stop`, {}, getAuthHeader());
  return response.data;
};

const restartBot = async () => {
  const response = await axios.post(`${API_URL}/restart`, {}, getAuthHeader());
  return response.data;
};

const getBotStatus = async () => {
  const response = await axios.get(`${API_URL}/status`, getAuthHeader());
  return response.data;
};

// Trading Operations
const setAmount = async (amount) => {
  const response = await axios.post(
    `${API_URL}/amount`,
    { amount },
    getAuthHeader()
  );
  return response.data;
};

const getAmount = async () => {
  const response = await axios.get(`${API_URL}/amount/latest`, getAuthHeader());
  return response.data;
};

// Trading Data
const getDirections = async () => {
  const response = await axios.get(`${API_URL}/directions`, getAuthHeader());
  return response.data;
};

const getDirectionHistory = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `${API_URL}/direction-history?page=${page}&limit=${limit}`,
      getAuthHeader()
    );
    
    if (response.data && response.data.success) {
      return {
        success: true,
        directionHistory: response.data.directionHistory || [],
        total: parseInt(response.data.total, 10) || 0,
        message: response.data.message
      };
    }
    
    // Fallback for different response format
    if (Array.isArray(response.data)) {
      return {
        success: true,
        directionHistory: response.data,
        total: response.data.length,
        message: 'Successfully retrieved direction history'
      };
    }
    
    return {
      success: false,
      directionHistory: [],
      total: 0,
      message: 'Invalid response format from server'
    };
  } catch (error) {
    console.error('Error in getDirectionHistory:', error);
    return {
      success: false,
      directionHistory: [],
      total: 0,
      message: error.response?.data?.message || 'Failed to fetch direction history'
    };
  }
};

const setTrendTracker = async (numberOfDirections) => {
  const response = await axios.post(
    `${API_URL}/trend-tracker`,
    { numberOfDirections },
    getAuthHeader()
  );
  return response.data;
};

const getTrendTracker = async () => {
  const response = await axios.get(`${API_URL}/trend-tracker`, getAuthHeader());
  return response.data;
};

const getOngoingTrade = async () => {
  try {
    const response = await axios.get(`${API_URL}/ongoing-trade`, getAuthHeader());
    // The API returns the trade data directly in response.data.data
    if (response.data && response.data.success) {
      return {
        success: true,
        data: response.data.data || null
      };
    }
    return { success: false, data: null };
  } catch (error) {
    // console.error('Error fetching ongoing trade:', error);
    // If it's a 404, it means no active trade
    if (error.response && error.response.status === 404) {
      return { success: true, data: null };
    }
    return { 
      success: false, 
      data: null,
      error: error.response?.data?.message || 'Failed to fetch ongoing trade'
    };
  }
};

// User Settings
const setDerivToken = async (userDerivToken, userId) => {
  const response = await axios.post(
    `${API_URL}/user-deriv-token`,
    { userDerivToken, user_id: userId },
    getAuthHeader()
  );
  return response.data;
};

// Export all functions
export {
    getDailyStatistics,
    setDailyStatistics,
  startBot,
  stopBot,
  restartBot,
  getBotStatus,
  setAmount,
  getAmount,
  getDirections,
  getDirectionHistory,
  setTrendTracker,
  getTrendTracker,
  getOngoingTrade,
  setDerivToken
};

// Also export as default for backward compatibility
// export default {
//   startBot,
//   stopBot,
//   restartBot,
//   getBotStatus,
//   setAmount,
//   getAmount,
//   getDirections,
//   getDirectionHistory,
//   setTrendTracker,
//   getTrendTracker,
//   getOngoingTrade,
//   setDerivToken
// };
